import { CommerceSupportingBlogLoop54Adapter } from '@agapi/commerce-loop54';
import { getShortDatedSlug } from '../utils/short-dated.shared';

import {
  // Loop54 API Urls
  PUBLIC_LOOP54_API_URL_SV,
  PUBLIC_LOOP54_API_URL_NB,
  PUBLIC_LOOP54_API_URL_DA,
  PUBLIC_LOOP54_API_URL_FI,
  PUBLIC_LOOP54_API_URL_EN,
  PUBLIC_LOOP54_API_URL_ES,
  // Loop54 API Keys
  PUBLIC_LOOP54_API_KEY_SV,
  PUBLIC_LOOP54_API_KEY_NB,
  PUBLIC_LOOP54_API_KEY_DA,
  PUBLIC_LOOP54_API_KEY_FI,
  PUBLIC_LOOP54_API_KEY_EN,
  PUBLIC_LOOP54_API_KEY_ES,
  // Loop54 Market IDs
  PUBLIC_MARKET_ID_SE,
  PUBLIC_MARKET_ID_NO,
  PUBLIC_MARKET_ID_DK,
  PUBLIC_MARKET_ID_FI,
  PUBLIC_MARKET_ID_ES,
  PUBLIC_MARKET_ID_GB,
  PUBLIC_MARKET_ID_DE
} from '$env/static/public';

const API_URLS = {
  sv: PUBLIC_LOOP54_API_URL_SV,
  nb: PUBLIC_LOOP54_API_URL_NB,
  da: PUBLIC_LOOP54_API_URL_DA,
  fi: PUBLIC_LOOP54_API_URL_FI,
  en: PUBLIC_LOOP54_API_URL_EN,
  es: PUBLIC_LOOP54_API_URL_ES,
}

const API_KEYS = {
  sv: PUBLIC_LOOP54_API_KEY_SV,
  nb: PUBLIC_LOOP54_API_KEY_NB,
  da: PUBLIC_LOOP54_API_KEY_DA,
  fi: PUBLIC_LOOP54_API_KEY_FI,
  en: PUBLIC_LOOP54_API_KEY_EN,
  es: PUBLIC_LOOP54_API_KEY_ES,
}

const MARKET_IDS = {
  se: PUBLIC_MARKET_ID_SE,
  no: PUBLIC_MARKET_ID_NO,
  dk: PUBLIC_MARKET_ID_DK,
  fi: PUBLIC_MARKET_ID_FI,
  es: PUBLIC_MARKET_ID_ES,
  gb: PUBLIC_MARKET_ID_GB,
  de: PUBLIC_MARKET_ID_DE,
}

const SHORT_DATED_SLUGS = {
  sv: getShortDatedSlug('sv'),
  nb: getShortDatedSlug('nb'),
  da: getShortDatedSlug('da'),
  fi: getShortDatedSlug('fi'),
  en: getShortDatedSlug('en'),
  es: getShortDatedSlug('es'),
}

/*
console.log('[commerce.ts]')
console.log('apiUrl', API_URLS);
console.log('apiKey', API_KEYS);
console.log('marketId', MARKET_IDS);
*/
export const getCommerce = (f: typeof window.fetch) => new CommerceSupportingBlogLoop54Adapter({
  fetch: f,
  apiKeys: API_KEYS,
  apiUrls: API_URLS,
  marketIds: MARKET_IDS,
  shortDatedSlugs: SHORT_DATED_SLUGS
});
